import React from 'react';
import ReactDOM from 'react-dom';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import AlertStore from './AlertStore';
import * as Actions from "./Actions"

import './Header.css';

class Header extends React.Component {

  componentWillMount() {
      AlertStore.on("save_changed", () => this.setState({save:AlertStore.getSave()}));
  }
  componentWillUnmount() {
    AlertStore.removeListener("save_changed");
  }

  loadSave() {
    if(this.state && this.state.save && "" != this.state.save) {
      Actions.loadSave(this.state.save);
    }
  }
  render() {
    return (
      <div className="header">
        <TextField onChange={e => Actions.setSave(e.target.value)} label="Storage Name / Email">{this.state != null ? this.state.save : ""}</TextField>
        <Button variant="contained" color="primary" onClick={() => {this.loadSave()}}>Load!</Button>
      </div>
    );
  }
}
export default Header;
